import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';

interface EducationSectionProps {
  mode?: 'full' | 'preview';
  bgClassName?: string;
}

interface Certificate {
  src: string;
  title: string;
  institution: string;
  year: string;
  alt: string;
}

const certificates: Certificate[] = [
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/2c773249-d35f-42f1-b0be-4fb169385196_compressed_IMG_8479.webp',
    title: 'Art-therapist as a Profession',
    institution: 'International Art-therapy School',
    year: '2023–2024',
    alt: 'Art-therapist as a Profession Certificate from International Art-therapy School 2023-2024'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/684ecb28-5901-4a29-95fa-e9b233ee3076_compressed_IMG_4520.webp',
    title: 'Art Therapy for Addiction & Co-Dependency',
    institution: 'National Institute for Advanced Professional Development',
    year: '2023',
    alt: 'Art Therapy for Addiction and Co-Dependency Certificate from National Institute for Advanced Professional Development Moscow 2023'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/f31b5f00-2fbe-4dc8-bfff-050ee7d430b4_compressed_IMG_8476.webp',
    title: 'Art Therapists Working with Groups',
    institution: 'International Art Therapy School',
    year: '2024',
    alt: 'Art Therapists Working with Groups Certificate from International Art Therapy School 2024'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/f6ca7458-35c0-41f0-9b10-b03ef87cd46e_compressed_IMG_5035.webp',
    title: 'NeuroGraphica Instructor',
    institution: 'Psychology of Creativity Institute',
    year: '2022',
    alt: 'NeuroGraphica Instructor Certificate from Psychology of Creativity Institute 2022'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/e60061ee-2243-4a53-b027-9274f0caca35_compressed_112.webp',
    title: 'NeuroGraphica Master',
    institution: 'Psychology of Creativity Institute',
    year: '2022',
    alt: 'NeuroGraphica Master Certificate from Psychology of Creativity Institute 2022'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/b1559977-7422-49ba-a1d8-00ed1644bc96_compressed_IMG_5034.webp',
    title: 'NG Aesthetic Coaching',
    institution: 'Psychology of Creativity Institute',
    year: '2022',
    alt: 'NG Aesthetic Coaching Certificate from Psychology of Creativity Institute 2022'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/f1e909f1-425b-401a-b568-e3409c1a0936_compressed_Art-therapy_page-0001.webp',
    title: 'Art Therapy for Self-Healing Diploma',
    institution: 'Renaissance Life Therapies',
    year: '2022',
    alt: 'Art Therapy for Self-Healing Diploma from Renaissance Life Therapies 2022'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/e75daf18-6042-4abe-990c-d5d291292b37_compressed_CPD-Certificate_page-0001.webp',
    title: 'CPD Certified Training',
    institution: 'The CPD Standards Office',
    year: 'Provider No. 50070',
    alt: 'CPD Certified Training Certificate from The CPD Standards Office Provider No. 50070'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/4a858a49-2486-48da-89e1-701dc613d528_compressed_IMG_4519.webp',
    title: 'Professional Retraining Diploma',
    institution: 'Academy of Continuing Professional Education and Development of Modern Competencies',
    year: '2024–2025',
    alt: 'Professional Retraining Diploma Psychologist-Consultant Art Therapist from Academy of Continuing Professional Education and Development of Modern Competencies 2024-2025'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/1811573e-a85a-4ccd-afe1-dd1e30201806_compressed_Addiction-Counselling_page-0001.webp',
    title: 'Certificate in Addictions Counselling',
    institution: 'The Online Counselling College',
    year: '2017',
    alt: 'Certificate in Addictions Counselling from The Online Counselling College 2017'
  }
];

const previewCertificates: Certificate[] = [
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/1811573e-a85a-4ccd-afe1-dd1e30201806_compressed_Addiction-Counselling_page-0001.webp',
    title: 'Certificate in Addictions Counselling',
    institution: 'The Online Counselling College',
    year: '2017',
    alt: 'Certificate in Addictions Counselling from The Online Counselling College 2017'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/f6ca7458-35c0-41f0-9b10-b03ef87cd46e_compressed_IMG_5035.webp',
    title: 'NeuroGraphica Instructor',
    institution: 'Psychology of Creativity Institute',
    year: '2022 (200 hours)',
    alt: 'NeuroGraphica Instructor Certificate from Psychology of Creativity Institute 2022'
  },
  {
    src: 'https://storage.helloreaddy.io/project_files/b4f3eeda-f893-4987-8921-4636c63c4dc6/2c773249-d35f-42f1-b0be-4fb169385196_compressed_IMG_8479.webp',
    title: 'Art-therapist as a Profession',
    institution: 'International Art-therapy School',
    year: '2023–2024 (250 hours)',
    alt: 'Art-therapist as a Profession Certificate from International Art-therapy School 2023-2024'
  }
];

export default function EducationSection({ mode = 'full', bgClassName }: EducationSectionProps) {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState<SwiperType | null>(null);
  const isPreview = mode === 'preview';
  const displayCertificates = isPreview ? previewCertificates : certificates;

  // Keyboard navigation for lightbox
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (!lightboxOpen) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [lightboxOpen, currentImageIndex]);

  const openLightbox = (index: number) => {
    if (isPreview) return;
    setCurrentImageIndex(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
    if (swiperInstance?.autoplay) {
      swiperInstance.autoplay.stop();
    }
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'unset';
    if (swiperInstance?.autoplay) {
      swiperInstance.autoplay.start();
    }
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % certificates.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + certificates.length) % certificates.length);
  };

  const renderCertificateCard = (certificate: Certificate, index: number) => (
    <div
      className={`group ${isPreview ? '' : 'cursor-pointer'}`}
      onClick={() => openLightbox(index)}
      key={index}
    >
      {/* Certificate Container */}
      <div
        className="bg-white rounded-lg p-4 transition-all duration-300 hover:shadow-2xl"
        style={{
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.05)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
        }}
      >
        {/* Certificate Image */}
        <div className="w-full aspect-[4/3] flex items-center justify-center overflow-hidden rounded">
          <img
            src={certificate.src}
            alt={certificate.alt}
            className="max-w-full max-h-full object-contain"
            loading="lazy"
          />
        </div>
      </div>

      {/* Certificate Info - Below the container */}
      <div className="mt-4 text-center">
        <h3
          className="font-normal text-base mb-2 text-[#312921]"
          style={{
            lineHeight: '1.4'
          }}
        >
          {certificate.title}
        </h3>
        <p className="text-sm mb-1 text-[#312921]/85">
          {certificate.institution}
        </p>
        {certificate.year && (
          <p className="text-sm text-[#312921]/85">
            {certificate.year}
          </p>
        )}
      </div>
    </div>
  );

  return (
    <>
      <section
        id="education"
        className={bgClassName || (isPreview ? 'pt-10 pb-10 bg-white' : 'pt-8 pb-8 bg-white')}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          {/* Header */}
          {isPreview ? (
            <div className="text-center">
              <Link
                to="/credentials"
                className="inline-block group cursor-pointer"
              >
                <h2
                  className="text-4xl lg:text-5xl font-normal text-center relative inline-block cinematic-text-dark transition-colors duration-200 group-hover:text-[#D6794E]"
                  style={{
                    fontFamily: 'Belanosima, sans-serif',
                    fontWeight: '400',
                    lineHeight: '1.3'
                  }}
                >
                  Education & Certification
                  {/* Accent underline */}
                  <div
                    className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-16 h-0.5"
                    style={{ backgroundColor: '#D6794E' }}
                  ></div>
                </h2>
              </Link>
              <p className="text-lg sm:text-xl text-[#312921]/85 max-w-3xl mx-auto px-4 mt-4">
                10 certifications in Art Therapy, Addiction Counselling and NeuroGraphica
              </p>
              <div className="mt-4 flex items-center justify-center">
                <Link
                  to="/credentials"
                  className="inline-flex items-center gap-2 text-sm font-normal underline cursor-pointer transition-opacity duration-300 hover:opacity-75 whitespace-nowrap"
                  style={{ color: '#D6794E' }}
                >
                  View all credentials
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ) : (
            <div className="text-center mb-4">
              <h2
                className="text-4xl lg:text-5xl font-normal text-center relative inline-block cinematic-text-dark"
                style={{
                  fontFamily: 'Belanosima, sans-serif',
                  fontWeight: '400',
                  lineHeight: '1.3'
                }}
              >
                Education & Certification
                {/* Accent underline */}
                <div
                  className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-16 h-0.5"
                  style={{ backgroundColor: '#D6794E' }}
                ></div>
              </h2>
            </div>
          )}

          {!isPreview && (
            /* Full Carousel */
            <div className="relative px-14 md:px-16">
              <Swiper
                modules={[Autoplay, Navigation]}
                loop={true}
                slidesPerView={1}
                spaceBetween={24}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true
                }}
                breakpoints={{
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 24
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 24
                  }
                }}
                navigation={{
                  prevEl: '.edu-prev-btn',
                  nextEl: '.edu-next-btn'
                }}
                onSwiper={setSwiperInstance}
                className="!overflow-visible"
              >
                {displayCertificates.map((certificate, index) => (
                  <SwiperSlide key={index}>
                    {renderCertificateCard(certificate, index)}
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* Navigation Arrows */}
              <button
                className="edu-prev-btn absolute left-0 top-1/3 -translate-y-1/2 text-[#385B47] hover:text-[#2F4C3B] transition-colors z-10 w-12 h-12 rounded-full flex items-center justify-center cursor-pointer"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                  backdropFilter: 'blur(10px)',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                }}
                aria-label="Previous certificate"
              >
                <i className="ri-arrow-left-line text-2xl"></i>
              </button>

              <button
                className="edu-next-btn absolute right-0 top-1/3 -translate-y-1/2 text-[#385B47] hover:text-[#2F4C3B] transition-colors z-10 w-12 h-12 rounded-full flex items-center justify-center cursor-pointer"
                style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                  backdropFilter: 'blur(10px)',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                }}
                aria-label="Next certificate"
              >
                <i className="ri-arrow-right-line text-2xl"></i>
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox */}
      {!isPreview && lightboxOpen && (
        <div
          className="fixed inset-0 bg-[#385B47]/95 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
          role="dialog"
          aria-modal="true"
          aria-label="Certificate lightbox"
        >
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            className="absolute top-6 right-6 cinematic-text-light hover:text-white transition-colors z-10 w-12 h-12 rounded-full flex items-center justify-center cursor-pointer"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)'
            }}
            aria-label="Close lightbox"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>

          {/* Navigation Arrows */}
          <button
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            className="absolute left-6 top-1/2 -translate-y-1/2 cinematic-text-light hover:text-white transition-colors z-10 w-12 h-12 rounded-full flex items-center justify-center cursor-pointer"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)'
            }}
            aria-label="Previous certificate"
          >
            <i className="ri-arrow-left-line text-2xl"></i>
          </button>

          <button
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            className="absolute right-6 top-1/2 -translate-y-1/2 cinematic-text-light hover:text-white transition-colors z-10 w-12 h-12 rounded-full flex items-center justify-center cursor-pointer"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)'
            }}
            aria-label="Next certificate"
          >
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>

          {/* Certificate Image */}
          <div className="max-w-5xl max-h-full flex items-center justify-center">
            <img
              src={certificates[currentImageIndex].src}
              alt={certificates[currentImageIndex].alt}
              className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          {/* Certificate Info */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-center max-w-md">
            <h3
              className="text-lg font-normal mb-2 cinematic-text-light"
            >
              {certificates[currentImageIndex].title}
            </h3>
            <p
              className="text-sm cinematic-text-light-secondary mb-1"
            >
              {certificates[currentImageIndex].institution}
            </p>
            {certificates[currentImageIndex].year && (
              <p
                className="text-xs cinematic-text-light-secondary"
              >
                {certificates[currentImageIndex].year}
              </p>
            )}
            <p
              className="text-xs cinematic-text-light-secondary mt-3"
            >
              {currentImageIndex + 1} of {certificates.length}
            </p>
          </div>
        </div>
      )}
    </>
  );
}